// extracted by mini-css-extract-plugin
module.exports = {"ArticleText":"styles_ArticleText__hKm8i","text":"styles_text__23eai"};